var exports = {
  "kL": "BottomCTASection.module__container___N0pXVT",
  "DD": "BottomCTASection.module__title___N0pXVT",
  "UD": "BottomCTASection.module__buttonContainer___N0pXVT",
  "x6": "BottomCTASection.module__button___N0pXVT",
};

module.exports = exports;
